"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleNetwork = void 0;
var vpt_abr_network_estimator_1 = require("@sky-uk-ott/vpt-abr-network-estimator");
var abr_types_1 = require("../../abr-types");
var bandwidth_utilisation_1 = require("../../bandwidth-utilisation/bandwidth-utilisation");
/**
 * ShakaAbrHeuristic:
 * The Shaka Heuristic continuously inspects the players buffer state
 * and bandwidth estimates in order to make decisions on track quality
 */
var SimpleNetwork = /** @class */ (function () {
    function SimpleNetwork(logger, bandwidthEstimator, latencyEstimator, bufferAssessment, config) {
        if (config === void 0) { config = {}; }
        var _a, _b;
        this.bandwidthEstimator = bandwidthEstimator;
        this.latencyEstimator = latencyEstimator;
        this.tracksAscending = [];
        this.nextSegmentDurationMs = 0;
        this.shouldWaitForBandwidth = true;
        this.logger = logger.withContext('SIMPLE_NETWORK');
        this.logger.info('Using config: ', config);
        var smootherConfig = config.smoother || { type: vpt_abr_network_estimator_1.SmootherType.LAST_SAMPLE };
        this.bandwidthSmoother = bandwidthEstimator.getSmoother(smootherConfig);
        var defaultBufferBandwidthUtilisationConfig = [
            {
                bufferThreshold: 12,
                bandwidthUtilisation: 0.9,
            },
            {
                bufferThreshold: 6,
                bandwidthUtilisationRange: {
                    minUtilisation: 0.5,
                    maxUtilisation: 0.8,
                    targetBufferUpperRange: 12,
                },
            },
            {
                bufferThreshold: 0,
                bandwidthUtilisation: 0.5,
            },
        ];
        if (config === null || config === void 0 ? void 0 : config.latencySmoother) {
            this.latencySmoother = this.latencyEstimator.getSmoother(config.latencySmoother);
        }
        this.bandwidthUtilisation = new bandwidth_utilisation_1.BandwidthUtilisation(bufferAssessment, {
            thresholds: (_b = (_a = config === null || config === void 0 ? void 0 : config.bandwidthUtilisation) === null || _a === void 0 ? void 0 : _a.thresholds) !== null && _b !== void 0 ? _b : defaultBufferBandwidthUtilisationConfig,
        });
    }
    SimpleNetwork.prototype.stopMonitorBufferState = function () {
        clearInterval(this.intervalId);
    };
    Object.defineProperty(SimpleNetwork.prototype, "name", {
        get: function () {
            return abr_types_1.AbrType.SIMPLE_NETWORK;
        },
        enumerable: false,
        configurable: true
    });
    SimpleNetwork.prototype.getRecommendedTracks = function (nextSegmentDurationSeconds) {
        this.nextSegmentDurationMs = nextSegmentDurationSeconds * 1000;
        if (!this.tracksAscending.length) {
            return null;
        }
        return this.chooseTracks();
    };
    SimpleNetwork.prototype.setTracksAscending = function (tracksAscending) {
        this.tracksAscending = tracksAscending;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    SimpleNetwork.prototype.notifiedPlaybackRateChange = function (rate) {
        // No-op
    };
    SimpleNetwork.prototype.suggestedBandwidth = function (bandwidthUsage) {
        var bandwidthEstimate = this.bandwidthSmoother.getValue();
        var suggestedBandwidth = Math.floor(bandwidthEstimate * bandwidthUsage);
        return suggestedBandwidth;
    };
    SimpleNetwork.prototype.getTrack = function (tracksAscending, suggestedBandwidth) {
        var _this = this;
        if (suggestedBandwidth === void 0) { suggestedBandwidth = 0; }
        var tracksDescending = tracksAscending.slice().reverse();
        var trackIndex = tracksDescending.findIndex(function (track) {
            if (_this.nextSegmentDurationMs && _this.latencySmoother) {
                var latency = _this.latencySmoother.getValue();
                if (latency) {
                    return track.combinedBandwidth < ((_this.nextSegmentDurationMs - latency) / _this.nextSegmentDurationMs) * suggestedBandwidth;
                }
            }
            return track.combinedBandwidth <= suggestedBandwidth;
        });
        if (trackIndex === -1) {
            return tracksAscending[0];
        }
        return tracksDescending[trackIndex];
    };
    SimpleNetwork.prototype.chooseTracks = function () {
        var _a;
        if (!((_a = this.tracksAscending) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        if (this.tracksAscending.length === 1) {
            return this.tracksAscending[0];
        }
        var bandwidthUtilisation = this.bandwidthUtilisation.getRecommendedUtilisation();
        var suggestedBandwidth = this.suggestedBandwidth(bandwidthUtilisation);
        return this.getTrack(this.tracksAscending, suggestedBandwidth);
    };
    SimpleNetwork.prototype.destroy = function () {
        var _a;
        this.bandwidthSmoother.unregister();
        (_a = this.latencySmoother) === null || _a === void 0 ? void 0 : _a.unregister();
    };
    return SimpleNetwork;
}());
exports.SimpleNetwork = SimpleNetwork;
